<template>
  <div>
    <div v-if="option && option.value">
      <div class="p-mb-2">{{ __("Description of the visit") }}:</div>
      <p-vue-textarea
        :autoResize="true"
        rows="4"
        class="p-inputtext--alt"
        v-model="desc"
      />
      <div class="p-d-flex p-jc-between p-mt-2">
        <p-vue-button
          class="button p-button-rounded p-button-success"
          :label="__('Save')"
          @click="save"
        />
        <p-vue-button
          class="button p-button-rounded p-button-success"
          :label="__('Cancel')"
          @click="close"
        />
      </div>
    </div>
    <div class="p-mb-4 p-d-flex p-flex-column" v-else>
      <div>{{ __("Has a visit been made to the building today?") }}</div>
      <i-override-select-button
        v-model="option"
        :options="Options"
        optionLabel="label"
        @change="optionChange"
      ></i-override-select-button>
    </div>
  </div>
</template>

<script>
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
export default {
  props: {
    BID: Number,
    close: Function,
  },
  emits: ["changeLastVisit"],
  data() {
    return {
      Options: [
        { label: __("No"), value: false },
        { label: __("Yes"), value: true },
      ],
      option: null,
      desc: __("General inspection of the building"),
      Subject: null,
    };
  },
  methods: {
    optionChange() {
      if (!this.option.value) {
        this.close();
      }
    },
    save() {
      this.Subject =
        this.userName + "  " + __("Paid a visit to the building today");

      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("PID", null, apiPType.Int),
        apiParam("ReportType", null, apiPType.TinyInt),
        apiParam("MtcGroupID", null, apiPType.Int),
        apiParam("ReportPriority", 2, apiPType.TinyInt),
        apiParam("Email", null, apiPType.NVarChar),
        apiParam("Subject", this.Subject, apiPType.NVarChar),
        apiParam("Desc", this.desc, apiPType.NVarChar),
        apiParam("ReturnPhone", null, apiPType.NVarChar),
        apiParam("DueDate", new Date(), apiPType.SmallDateTime),
        apiParam("ClosingDate", new Date(), apiPType.SmallDateTime),
        apiParam("WorkerNum", null, apiPType.Int),
        apiParam("SupplierNum", null, apiPType.Int),
        apiParam("BID", this.BID, apiPType.Int),
        apiParam("UID", null, apiPType.Int),
        apiParam("ReportName", null, apiPType.NVarChar),
        apiParam("SmsSentToSupplier", false, apiPType.Bit),
        apiParam("ContentSMSToSupplier", "", apiPType.NVarChar),
      ];
      // console.log(procParams);
      callProc("WorkerApp_UpdateOrInsertProblem", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(
              __("Last visit date successfully changed")
            );
            setTimeout(() => {
              this.$emit("changeLastVisit", this.BID);
            }, 2000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
            setTimeout(() => {
              this.close();
            }, 2000);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch((err) => {
          console.log(err);
          errorReceived("WorkerApp_UpdateOrInsertProblem");
        });
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
      userName: (state) => state.api.User.userName,
    }),
  },
};
</script>

<style scoped>
:deep(.p-selectbutton .p-highlight) {
  background-color: var(--color-success);
  border-color: var(--color-success);
}

:deep(.p-selectbutton .p-highlight:hover) {
  background-color: var(--color-success);
  border-color: var(--color-success);
}

:deep(.p-override-select-button) {
  width: 100%;
  margin-top: 10px;
}

:deep(.p-selectbutton.p-buttonset.p-component) {
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
}

:deep(.p-override-select-button .p-buttonset .p-button:first-of-type) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

:deep(.p-override-select-button .p-buttonset .p-button:last-of-type) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.p-inputtextarea {
  width: 100%;
}
</style>
